import apiClient from "../../api/api";
import { API_ENDPOINTS } from "../../api/api.config";

export interface PostgresConnection {
  host: string;
  port?: number;
  database: string;
  user: string;
  password?: string;
  /** SSL mode: "disable" | "allow" | "require" (or legacy boolean). */
  ssl?: boolean | string;
}

const postgresService = {
  testConnection: async (connection: PostgresConnection) => {
    try {
      const res = await apiClient.post(API_ENDPOINTS.POSTGRES.TEST_CONNECTION, { connection });
      return res.data;
    } catch (error: any) {
      return error.response?.data || { success: false, error: error.message || "Connection failed" };
    }
  },
  listSchemas: async (connection: PostgresConnection) => {
    const res = await apiClient.post(API_ENDPOINTS.POSTGRES.SCHEMAS, { connection });
    return res.data;
  },
  listTables: async (connection: PostgresConnection, schema: string) => {
    const res = await apiClient.post(API_ENDPOINTS.POSTGRES.TABLES, { connection, schema });
    return res.data;
  },
  listColumns: async (connection: PostgresConnection, schema: string, table: string) => {
    const res = await apiClient.post(API_ENDPOINTS.POSTGRES.COLUMNS, { connection, schema, table });
    return res.data;
  },
  addColumn: async (
    connection: PostgresConnection,
    schema: string,
    table: string,
    name: string,
    data_type: string,
    nullable: boolean,
  ) => {
    try {
      const res = await apiClient.post(API_ENDPOINTS.POSTGRES.ADD_COLUMN, { connection, schema, table, name, data_type, nullable });
      return res.data;
    } catch (error: any) {
      return error.response?.data || { success: false, error: error.message || "Failed to add column" };
    }
  },
};

export default postgresService;
